module.exports = __webpack_public_path__ + "img/073429.23c2958c.png";